import { render, staticRenderFns } from "./DocumentEmailToMeModal.vue?vue&type=template&id=7a83ce9c&scoped=true&"
import script from "./DocumentEmailToMeModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentEmailToMeModal.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEmailToMeModal.vue?vue&type=style&index=0&id=7a83ce9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a83ce9c",
  null
  
)

export default component.exports